import { isDefined } from '@grandvisionhq/utils';
import { useBrPageContext } from '../context/context.js';

const useBloomreachPageHasComponent = ({ componentName  })=>{
    const page = useBrPageContext();
    const component = page === null || page === void 0 ? void 0 : page.getComponent('main', 'container', componentName);
    const isComponentDefined = isDefined(component);
    return isComponentDefined;
};

export { useBloomreachPageHasComponent };
//# sourceMappingURL=use-bloomreach-page-has-component.js.map
